module.exports = __webpack_public_path__ + "./favicons/android-icon-96x96.png";